import { render, staticRenderFns } from "./RecentContributionsAll.vue?vue&type=template&id=44b22d28&scoped=true"
import script from "./RecentContributionsAll.vue?vue&type=script&lang=ts"
export * from "./RecentContributionsAll.vue?vue&type=script&lang=ts"
import style0 from "./RecentContributionsAll.vue?vue&type=style&index=0&id=44b22d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b22d28",
  null
  
)

export default component.exports